import React, { useEffect, useState } from "react";
import "./SolutionDetailsDescription.css";
import { resolveMediaUrl } from "../../../../utils/media";
import leftArrowIcon from "../../../../assets/icons/left.svg";
import rightArrowIcon from "../../../../assets/icons/right.svg";

const SolutionDetailsDescription = ({ solution, activeTabIndex, onActiveTabChange }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    setActiveTab(0);
    setActiveImageIndex(0);
  }, [solution?.slug, solution?.solutionKey, solution?.id]);

  if (!solution) return null;

  const tabs = Array.isArray(solution.descriptionTabs)
    ? solution.descriptionTabs
        .map((tab, index) => {
          if (typeof tab === "string") {
            return {
              key: `${tab}-${index}`,
              label: tab,
              imageUrl: "",
              descriptionBody: "",
              displayOrder: index,
            };
          }
          return {
            key: String(tab?.id ?? `${tab?.label || "tab"}-${index}`),
            label: tab?.label || "",
            descriptionBody: tab?.descriptionBody || tab?.description || "",
            imageUrls: [
              ...(Array.isArray(tab?.tabImageUrls) ? tab.tabImageUrls : []),
              ...String(tab?.tabImageUrl || "")
                .split("|")
                .map((v) => v.trim())
                .filter(Boolean),
              tab?.imageUrl,
              tab?.image,
            ]
              .map((v) => resolveMediaUrl(v))
              .filter(Boolean),
            displayOrder:
              typeof tab?.displayOrder === "number" ? tab.displayOrder : index,
          };
        })
        .filter((tab) => Boolean(tab.label))
        .sort((a, b) => a.displayOrder - b.displayOrder)
    : [];
  const isControlled = typeof activeTabIndex === "number";
  const rawTabIndex = isControlled ? activeTabIndex : activeTab;
  const safeTabIndex = Number.isFinite(rawTabIndex) ? rawTabIndex : 0;
  const selectedTabIndex = tabs.length
    ? Math.max(0, Math.min(safeTabIndex, tabs.length - 1))
    : 0;
  const cardIcon =
    resolveMediaUrl(solution.cardIconUrl || solution.cardIcon || solution.iconUrl || solution.icon) ||
    solution.cardIcon;
  const selectedTabImages = tabs[selectedTabIndex]?.imageUrls?.length
    ? tabs[selectedTabIndex].imageUrls
    : [cardIcon].filter(Boolean);
  const selectedTabDescription =
    String(tabs[selectedTabIndex]?.descriptionBody || tabs[selectedTabIndex]?.description || "").trim() ||
    solution.descriptionBody ||
    solution.cardDescription ||
    "";
  const safeImageIndex = Math.min(activeImageIndex, Math.max(0, selectedTabImages.length - 1));
  const selectedTabImage = selectedTabImages[safeImageIndex] || "";

  const showImageArrows = selectedTabImages.length > 1;
  const goToPrevImage = () => {
    setActiveImageIndex((prev) => (prev - 1 + selectedTabImages.length) % selectedTabImages.length);
  };
  const goToNextImage = () => {
    setActiveImageIndex((prev) => (prev + 1) % selectedTabImages.length);
  };

  return (
    <section className="solutionDesc">
      <div className="solutionDesc-tabs">
        {tabs.map((tab, index) => (
          <div
            key={tab.key}
            className={`solutionDesc-tab ${
              selectedTabIndex === index ? "active" : ""
            }`}
            onClick={() => {
              setActiveTab(index);
              onActiveTabChange?.(index);
              setActiveImageIndex(0);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setActiveTab(index);
                onActiveTabChange?.(index);
                setActiveImageIndex(0);
              }
            }}
          >
            {tab.label}
          </div>
        ))}
      </div>

      <div className="solutionDesc-content">
        <div className="solutionDesc-left">
          <h3>System description</h3>

          <p>{selectedTabDescription}</p>
        </div>

        <div className="solutionDesc-right">
          <img
            className="tabimagesol"
            src={selectedTabImage}
            alt={tabs[selectedTabIndex]?.label || solution.title || ""}
            draggable={false}
          />
          {showImageArrows ? (
            <div className="solutionDesc-imageArrows">
              <button
                type="button"
                className="solutionDesc-imageArrow"
                onClick={goToPrevImage}
                aria-label="Previous tab image"
              >
                <img src={leftArrowIcon} alt="" aria-hidden />
              </button>
              <button
                type="button"
                className="solutionDesc-imageArrow"
                onClick={goToNextImage}
                aria-label="Next tab image"
              >
                <img src={rightArrowIcon} alt="" aria-hidden />
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default SolutionDetailsDescription;
